<template>
  <div id="app" class="p-4">
    <form
      @submit.prevent="enviarFormulario"
      class="max-w-lg mx-auto bg-gray-800 p-6 rounded-lg shadow-lg"
    >
      <h2 class="text-2xl font-semibold text-orange-500 mb-4">
        Informacion general
      </h2>
      <div class="mb-4">
        <label class="block text-lg text-gray-300">Tipo de gasto</label>
        <input
          v-model="gasto.tipo.nombre"
          type="text"
          placeholder=""
          @click="buscarSugerenciasTipos"
          @input="buscarSugerenciasTipos"
          @blur="ocultarSugerenciasTiposConRetraso"
          class="mt-2 w-full p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
        />
        <!-- Sugerencias de clientes -->
        <ul
          v-if="mostrarSugerenciasTipos"
          class="sugerencias mt-2 list-none p-0 bg-white text-gray-800 border border-gray-300 rounded-md shadow-lg"
        >
          <li
            v-for="sugerencia in sugerenciasTipos"
            :key="sugerencia.ID"
            @click="seleccionarSugerenciaTipos(sugerencia)"
            class="px-4 py-2 cursor-pointer hover:bg-orange-200"
          >
            {{ sugerencia.DESCRIPCION }}
          </li>
        </ul>
      </div>

      <div class="mb-4">
        <label class="block text-lg text-gray-300">Subtipo de gasto</label>
        <input
          v-model="gasto.subtipo.nombre"
          type="text"
          placeholder=""
          @click="buscarSugerenciasSubTipos"
          @input="buscarSugerenciasSubTipos"
          @blur="ocultarSugerenciasSubTiposConRetraso"
          class="mt-2 w-full p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
        />
        <!-- Sugerencias de clientes -->
        <ul
          v-if="mostrarSugerenciasSubTipos"
          class="sugerencias mt-2 list-none p-0 bg-white text-gray-800 border border-gray-300 rounded-md shadow-lg"
        >
          <li
            v-for="sugerencia in sugerenciasSubTipos"
            :key="sugerencia.ID"
            @click="seleccionarSugerenciaSubTipos(sugerencia)"
            class="px-4 py-2 cursor-pointer hover:bg-orange-200"
          >
            {{ sugerencia.DESCRIPCION }}
          </li>
        </ul>
      </div>

      <div class="mb-4">
        <label class="block text-lg text-gray-300">Descripcion</label>
        <textarea
          v-model="gasto.descripcion"
          placeholder=""
          class="mt-2 w-full p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
          rows="3"
        ></textarea>
       
      </div>

      <div class="mb-4">
        <label class="block text-lg text-gray-300">Monto</label>
        <input
          v-model="gasto.monto"
          type="text"
          placeholder=""
          class="mt-2 w-full p-3 rounded-md bg-gray-600 text-white border border-gray-500 focus:ring-2 focus:ring-orange-500"
        />
        <!-- Sugerencias de clientes -->
      
      </div>
    </form>
    <!-- Formulario para agregar productos y generar presupuesto -->

    <!-- Botón para generar presupuesto -->
    <div class="mt-6 max-w-lg mx-auto">
      <button
        @click="enviarFormulario"
        class="w-full py-3 text-lg text-white bg-green-500 rounded-md hover:bg-green-600"
      >
        Registrar Gasto
      </button>
    </div>
  </div>
</template>

<script>
import GastosProvider from "@/helpers/providers/GastosProvider";

export default {
  data() {
    return {
      mostrarAjuste: false,
      gasto: {
        tipo: { id: 0, nombre: "" },
        subtipo: { id: 0, idTipo: 0, nombre: "" },
        descripcion: "",
        monto: 0,
      },
      // venta: {
      //   cliente: { ID_CLIENTE: 0, Nombre: "" },
      //   productos: this.$route.params.productos || [],
      //   adicional: {
      //     tipoAjuste: 0, // "descuento" o "recargo"
      //     modoAjuste: 0, // "porcentaje" o "monto"
      //     valorAjuste: 0,
      //   },
      // },
      nuevoProducto: {
        nombre: "VARIOS",
        precio: 0,
        cantidad: 1,
      },
      tiposMemoria: [],
      sugerenciasTipos: [],
      mostrarSugerenciasTipos: false,

      subTiposMemoria: [],
      sugerenciassubTipos: [],
      mostrarSugerenciasSubTipos: false,
      // sugerencias: [],
      // mostrarSugerencias: false,
      // productosMemoria: [],
      // clientesMemoria: [],
      // sugerenciasClientes: [],
      // mostrarSugerenciasClientes: false,
    };
  },

  methods: {
    toggleAjuste() {
      this.mostrarAjuste = !this.mostrarAjuste; // Alterna la visibilidad del ajuste
    },

    async cargarTipos() {
      try {
        this.tiposMemoria = await GastosProvider.getTipos();
      } catch (error) {
        console.error("Error al cargar productos:", error);
      }
    },
    buscarSugerenciasTipos() {
      const query = this.gasto.tipo.nombre;
      //console.log(query);
      this.sugerenciasTipos = this.tiposMemoria.filter((tipo) =>
        tipo.DESCRIPCION.toLowerCase().includes(query.toLowerCase())
      );

      this.mostrarSugerenciasTipos = this.sugerenciasTipos.length > 0;
    },
    async seleccionarSugerenciaTipos(tipo) {
      //console.log(cliente)
      this.gasto.tipo.nombre = tipo.DESCRIPCION;
      this.gasto.tipo.id = tipo.ID;
      this.mostrarSugerenciasTipos = false;
      this.$notiflix.Loading.standard();
      await this.cargarSubTipos(tipo.ID);
      this.$notiflix.Loading.remove();
    },
    ocultarSugerenciasTipoConRetraso() {
      setTimeout(() => {
        this.mostrarSugerenciasTipos = false;
      }, 200);
    },

    async cargarSubTipos(idTipo) {
      try {
        this.subTiposMemoria = await GastosProvider.getSubTipos(idTipo);
      } catch (error) {
        console.error("Error al cargar productos:", error);
      }
    },
    buscarSugerenciasSubTipos() {
      const query = this.gasto.subtipo.nombre;
      //console.log(this.subTiposMemoria);
      this.sugerenciasSubTipos = this.subTiposMemoria.filter((subtipo) =>
        subtipo.DESCRIPCION.toLowerCase().includes(query.toLowerCase())
      );

      this.mostrarSugerenciasSubTipos = this.sugerenciasSubTipos.length > 0;
    },
    seleccionarSugerenciaSubTipos(subtipo) {
      //console.log(cliente)
      this.gasto.subtipo.nombre = subtipo.DESCRIPCION;
      this.gasto.subtipo.id = subtipo.ID;
      this.gasto.subtipo.idTipo = subtipo.ID_TIPO;
      this.mostrarSugerenciasSubTipos = false;
    },
    ocultarSugerenciasSubTipoConRetraso() {
      setTimeout(() => {
        this.mostrarSugerenciasTipos = false;
      }, 200);
    },
    async enviarFormulario() {
      try {
        this.$notiflix.Loading.standard();
        const respuesta = await GastosProvider.newGasto(this.gasto);
        this.$notiflix.Loading.remove();
        if (respuesta) {
          this.$notiflix.Notify.success(
            "Gasto registrada con éxito.",
          );
          this.gasto = {
            tipo: { id: 0, nombre: "" },
            subtipo: { id: 0, idTipo: 0, nombre: "" },
            descripcion: "",
            monto: 0,
          };
          this.tiposMemoria = await GastosProvider.getTipos();
          
        } else {
          this.$notiflix.Report.failure(
            "Error al registrar gasto",
            "Compruebe los campos e intente nuevamente.",
            "Cerrar"
          );
        }
      } catch (error) {
        this.$notiflix.Report.failure(
            "Error al registrar gasto",
            "Compruebe los campos e intente nuevamente.",
            "Cerrar"
          );
      }
    },
  },
  async mounted() {
    this.$notiflix.Loading.standard();
    await this.cargarTipos();
    this.$notiflix.Loading.remove();
  },
};
</script>
<!-- venta: {
        cliente: { ID_CLIENTE: 0, Nombre: "" },
        productos: this.$route.params.productos || [],
        adicional: {
          tipoAjuste: 0, // "descuento" o "recargo"
          modoAjuste: 0, // "porcentaje" o "monto"
          valorAjuste: 0,
        },
      }, -->
